import { createAsyncThunk } from "@src/store/createAsyncThunk";
import { experienceBuilderAiSlice } from "@src/store/slices/experienceBuilder/ai/slice";

import { ideasSlice } from "../slice";

const { _openLibrary } = ideasSlice.actions;
const { setOpen } = experienceBuilderAiSlice.actions;

/**
 * Opens the Idea Library, revealing the chat panel first when it's minimized —
 * the library renders inside that panel (see `ExperienceBuilderDialog`), so
 * opening it against a collapsed panel would show nothing, and sending an idea
 * from it would fire a turn the merchant can't see.
 *
 * Every entry point goes through here (the empty state's link, the toolbar
 * menu) so they can't drift; tracking stays on the `_openLibrary` action, which
 * this always dispatches exactly once.
 */
export const openLibrary = createAsyncThunk<void, void>(
  "experienceBuilderIdeas/openLibrary",
  (_, { dispatch, getState }) => {
    // Guarded rather than dispatched unconditionally: `setOpen` is what
    // `chat_toggled` event, so re-opening an open panel would log a
    // phantom toggle.
    if (!experienceBuilderAiSlice.selectors.isOpen(getState())) {
      dispatch(setOpen(true));
    }
    dispatch(_openLibrary());
  }
);
